function HistoryDetails({ history }) {
  
  return (
    <>
      <div className="history-section service2-section mb-50">
        <div className="container">
          <div className="section-title2 primary3">
            <span>{history.highlist_title}</span>
            <div>
              <h2>{history.sub_title}</h2>
            </div>
          </div>
          <div className="history-list">
            {
              history.services_list && history.services_list.length &&
              history.services_list.map((history, index) => {
                const isRight = index % 2 !== 0;
                return (
                  <div className={`history-item ${index % 2 === 0 ? "left" : "right"}`} >
                    <div className="row">
                      <div className={`col-12 col-lg-6 image-wrap ${isRight ? "order-lg-1" : "order-lg-2"}`} >
                        <div className="right-number">
                          <span className="history-number-large">
                            {history.title}
                          </span>
                        </div>
                      </div>
                      <div
                        className={`col-12 col-lg-6 content-wrapper ${isRight ? "order-lg-2" : "order-lg-1"}`} >
                        <div className="service-content">
                          {/* <span>{index + 1}</span> */}
                          <div className="history-icon"></div>
                          <span><h4>{history.title}</h4></span>
                          <p className="para">
                            {history.short_description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default HistoryDetails;